<template>
  <div>
    <slot />
  </div>
</template>
<style src="~/assets/styles/fancybox.min.css" lang="css" ></style>
<style>

</style>
